import { DefaultModal } from "../DefaultModal";
import { useModalContext } from "../../ModalProvider";
import React from "react";

type SuccessModalContainerProps = React.ComponentProps<"div">;
export const SuccessModalContainer = ({
  children,
}: SuccessModalContainerProps) => {
  const { closeModal } = useModalContext();

  return (
    <DefaultModal onClose={() => closeModal()}>
      <div
        className={
          "px-2 pt-8 pb-10 lg:px-20 lg:py-8 flex flex-col items-stretch justify-center"
        }
      >
        {children}
      </div>
    </DefaultModal>
  );
};
